import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'

import ApiService from '@/services/Api'
import {
    Grid,
    CircularProgress,
    Card,
    CardContent,
    Typography,
    Box
} from '@mui/material'

import useStyles from './styles'

declare global {
    interface Window {
        google: any
    }
}

const Audience: React.FC = () => {
    const classes = useStyles()
    const { enqueueSnackbar } = useSnackbar()
    const [loadingCredentials, setLoadingCredentials] = useState<boolean>(false)

    useEffect(() => {
        // Carrega o script do Google Identity Services
        const script = document.createElement('script')
        script.src = 'https://accounts.google.com/gsi/client'
        script.async = true
        script.defer = true
        document.body.appendChild(script)

        script.onload = () => {
            if (window.google) {
                const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID

                if (!clientId) {
                    console.error('❌ GOOGLE_CLIENT_ID não está definido!')
                    return
                }

                window.google.accounts.id.initialize({
                    client_id: clientId,
                    callback: handleCredentialResponse
                })

                window.google.accounts.id.renderButton(
                    document.getElementById('googleSignInButton'),
                    {
                        theme: 'outline',
                        size: 'large',
                        text: 'signin_with',
                        width: 300,
                        logo_alignment: 'left'
                    }
                )
            }
        }

        return () => {
            if (document.body.contains(script)) {
                document.body.removeChild(script)
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCredentialResponse = async (response: any) => {
        if (loadingCredentials) return

        setLoadingCredentials(true)

        try {
            const { data } = await ApiService.post('/auth/login', {
                idToken: response.credential
            })

            localStorage.setItem('token', data.token)

            enqueueSnackbar('Login realizado com sucesso!', {
                variant: 'success'
            })

            // Redireciona após 500ms
            setTimeout(() => {
                window.location.href = '/'
            }, 500)
        } catch (error: any) {
            setLoadingCredentials(false)

            // Extrai a mensagem de erro
            let errorMessage = 'Ocorreu um erro ao fazer login'

            // O erro vem no formato: { data: { message: '...' } }
            if (error?.data?.message) {
                errorMessage = error.data.message
            }

            enqueueSnackbar(errorMessage, {
                variant: 'error'
            })

            // Re-renderiza o botão do Google após o erro
            setTimeout(() => {
                if (window.google && document.getElementById('googleSignInButton')) {
                    window.google.accounts.id.renderButton(
                        document.getElementById('googleSignInButton'),
                        {
                            theme: 'outline',
                            size: 'large',
                            text: 'signin_with',
                            width: 300,
                            logo_alignment: 'left'
                        }
                    )
                }
            }, 100)
        }
    }

    return (
        <Grid container className={classes.container} alignContent="center" justifyContent="center">
            <Card className={classes.cardContainer}>
                <CardContent className={classes.cardContent}>
                    <Box textAlign="center" mb={3}>
                        <Typography variant="h5" component="h1" gutterBottom>
                            Loopert Intranet
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            Faça login com sua conta @loopert.com
                        </Typography>
                    </Box>

                    <Grid item className={classes.input}>
                        <Box display="flex" justifyContent="center" alignItems="center">
                            {loadingCredentials ? (
                                <CircularProgress size={40} />
                            ) : (
                                <div id="googleSignInButton"></div>
                            )}
                        </Box>
                    </Grid>

                    <Box mt={2} textAlign="center">
                        <Typography variant="caption" color="textSecondary">
                            Apenas e-mails @loopert.com são permitidos
                        </Typography>
                    </Box>
                </CardContent>
            </Card>
        </Grid>
    )
}

export default Audience
